import { useTournamentsNavLinks } from "./hooks";
import TournamentsNav from "./TournamentsNav";

const TournamentsNavContainer: React.FC = () => {
  const { navLinks } = useTournamentsNavLinks();
  return <TournamentsNav navLinks={navLinks} />;
};

export default TournamentsNavContainer;
